import { useEffect, useState } from 'react';
import useImage from 'use-image';
export default function useImageAdvanced(url, opts = {}) {
  const {
    height,
    width
  } = opts;
  const [image, setImage] = useState();
  const [scale, setScale] = useState();
  const [loadedImage] = useImage(url, 'anonymous');
  useEffect(() => {
    if (loadedImage) {
      if (width != null && height != null) {
        const imgNaturalHeight = loadedImage.naturalHeight;
        const imgNaturalWidth = loadedImage.naturalWidth;
        const hRatio = width / imgNaturalWidth;
        const vRatio = height / imgNaturalHeight;
        const ratio = Math.min(hRatio, vRatio);
        loadedImage.width = imgNaturalWidth * ratio;
        loadedImage.height = imgNaturalHeight * ratio;
        setScale(ratio);
      }
      setImage(loadedImage);
    }
  }, [loadedImage, height, width]);
  return {
    image,
    scale
  };
}